import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import formatParams from './util/formatParams'

interface IOpenPage {
  url: string
  title: string
}

/**
 * 打开新的外部链接
 *
 * @param {IBridgeOptions<IOpenPage>} { url = '', title = '', success, fail, complete }
 */
function openPageSync({
  url = '',
  title = '',
  success,
  fail,
  complete
}: IBridgeOptions<IOpenPage>) {
  const params = formatParams({
    funType: 'forward',
    funName: 'forwardWebPage',
    url,
    title
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('openPage error: ', error)
  }
}

/**
 * 打开新的外部链接
 * 一个异步接口，支持 Promise 化使用
 * @param {IBridgeOptions<IOpenPage>} { url = '', title = '' }
 * @returns
 */
function openPage({ url = '', title = '' }: IBridgeOptions<IOpenPage>) {
  const params = formatParams({
    funType: 'forward',
    funName: 'forwardWebPage',
    url,
    title
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }

  return nativeJSBridge(opts)
}

export { openPage, openPageSync }
